<crm-association-form-field
  [associations]="associationsList()"
  [options]="(options$ | async) ?? []"
  [placeholder]="'ASSOCIATION_FORM.PLACEHOLDER' | translateByObjectType: objectType()"
  (add)="handleAdd($event)"
  (remove)="handleRemove($event)"
  (searchTermChange)="updateSearchTerm($event)"
></crm-association-form-field>
